"use client";

import classnames from "classnames";

import styles from "./toggle.module.scss";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  "aria-label"?: string;
  "data-testid"?: string;
}

export function Toggle({
  checked,
  onChange,
  "aria-label": ariaLabel,
  "data-testid": testId,
}: ToggleProps) {
  return (
    <button
      type="button"
      className={classnames(styles.toggle, checked && styles.checked)}
      onClick={() => onChange(!checked)}
      data-testid={testId}
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
    >
      <span className={styles.thumb} />
    </button>
  );
}
